import type { AlpineComponent } from 'alpinejs';

type BalanceMaskData = {
  factor: number;
  intrinsicWidth: number;
  scale: number;
  rescale: () => void;
};

const BalanceMask = (): AlpineComponent<BalanceMaskData> => ({
  /**
   * Scaling factor that gets applied to the ratio between intrinsic and actual width
   */
  factor: 0.5,

  /**
   * Intrinsic width of the SVG mask, in px
   */
  intrinsicWidth: 1600,

  /**
   * Final scaling factor that should be applied to the balance bars
   */
  scale: 1,

  rescale() {
    this.scale =
      (this.factor * this.intrinsicWidth) /
      this.$root.getBoundingClientRect().width;
  },

  init() {
    this.rescale();
  }
});

export default BalanceMask;
